"use client";
import { Icon } from "@/components";
import { Button } from "@/components/button";
import { Card } from "@/components/card";
import Image from "next/image";
import React from "react";

type TCarouselItem = {
  children: React.ReactNode;
  image?: string;
};

export const CarouselItem: React.FC<TCarouselItem> = ({ children, image }) => {
  return (
    <Card>
      <h3 className="block w-52 font-semibold text-lg lg:text-2xl">
        {children}
      </h3>
      <Button variant="icon" className="group">
        <Icon
          icon="FaPlus"
          className="text-2xl -rotate-90 group-hover:rotate-90 duration-300"
        />
      </Button>
      {image && (
        <Image
          src={`/${image}`}
          width={1000}
          height={1000}
          alt="Quero falar sobre escolas"
          className="right-2 bottom-4 lg:bottom-1 group-hover:bottom-3.5 absolute w-40 lg:w-32 xl:w-50 transition-all duration-300"
        />
      )}
    </Card>
  );
};
